export enum BackgroundInfoTemplateEnum {
  Entity = 1,
  Transaction,
  UncontrolledTransaction,
}
